import { useAuth0 } from "@auth0/auth0-react";
import { useLocation, Navigate } from "react-router-dom";
import { useAppContext } from "../context/AppContext";
import Loader from "../components/utilPages/Loader";

/**
 * Protects routes by auth and optional role.
 * - requireAuth only: redirects to login (with returnTo) if not logged in; after login user returns here (e.g. Profile).
 * - requiredRoles (e.g. premiumRoles): redirects if not logged in or role not in list (e.g. Constructor).
 * - requiredRoles = ['admin']: redirects if not logged in or not admin (e.g. Admin dashboard).
 */
export default function RequireAuthRoute({ children, requiredRoles = null }) {
  const { isAuthenticated, isLoading: authLoading, loginWithRedirect } = useAuth0();
  const { user, loading } = useAppContext();
  const location = useLocation();

  if (authLoading) {
    return <Loader load />;
  }

  if (!isAuthenticated) {
    const returnTo = location.pathname + location.search;
    window.localStorage.setItem("redirectTo", returnTo);
    loginWithRedirect();
    return <Loader load />;
  }

  if (requiredRoles && requiredRoles.length > 0) {
    // Wait for app user to be loaded (user can be null while loading after auth)
    if (loading || user === undefined) {
      return <Loader load />;
    }
    if (!user || !requiredRoles.includes(user.role)) {
      return <Navigate to="/not-found" replace />;
    }
  }

  return children;
}
